<template>
  <div
    v-if="variants.v1 === variant"
    class="tw-border tw-px-6 tw-py-8"
    style="border-radius: var(--rounded)"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-bottom: 1px solid var(--c-${vars.borderBottomColor}); border-top: 1px solid var(--c-${vars.borderTopColor});`"
  >
    <h3 class="tw-pb-6">{{ vars.titleText }}</h3>
    <div class="tw-flex tw-h-full tw-min-h-[400px] tw-flex-col tw-gap-6 tw-rounded-lg tw-border-2 tw-p-3 tw-text-start">
      <NuxtImg :src="vars.photoImage" />
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-text-center">
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1">
          <h6>{{ vars.nameText }} {{ vars.surnameText }}</h6>
          <span class="tw-font-bold">{{ vars.roleText }}</span>
        </div>
        <div class="tw-flex tw-w-full tw-flex-col tw-items-center">
          <div class="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-break-words">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.34 10.2533C12.52 10.2533 11.7267 10.12 10.9867 9.88C10.8707 9.8407 10.7461 9.83487 10.627 9.86317C10.5079 9.89147 10.3992 9.95275 10.3133 10.04L9.26667 11.3533C7.38 10.4533 5.61333 8.75333 4.67333 6.8L5.97333 5.69333C6.15333 5.50667 6.20667 5.24667 6.13333 5.01333C5.88667 4.27333 5.76 3.48 5.76 2.66C5.76 2.3 5.46 2 5.1 2H2.79333C2.43333 2 2 2.16 2 2.66C2 8.85333 7.15333 14 13.34 14C13.8133 14 14 13.58 14 13.2133V10.9133C14 10.5533 13.7 10.2533 13.34 10.2533Z"
                fill="black"
              />
            </svg>
            <nuxt-link :to="`tel: ${vars.phoneText}`" class="n-link tw-max-w-full">{{ vars.phoneText }}</nuxt-link>
          </div>
          <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-text-wrap">
            <span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.66671 13.3334C2.30004 13.3334 1.98604 13.2027 1.72471 12.9414C1.46338 12.68 1.33293 12.3662 1.33338 12V4.00002C1.33338 3.63335 1.46404 3.31935 1.72538 3.05802C1.98671 2.79669 2.30049 2.66624 2.66671 2.66669H13.3334C13.7 2.66669 14.014 2.79735 14.2754 3.05869C14.5367 3.32002 14.6672 3.6338 14.6667 4.00002V12C14.6667 12.3667 14.536 12.6807 14.2747 12.942C14.0134 13.2034 13.6996 13.3338 13.3334 13.3334H2.66671ZM8.00004 8.66669L13.3334 5.33335V4.00002L8.00004 7.33335L2.66671 4.00002V5.33335L8.00004 8.66669Z"
                  fill="black"
                />
              </svg>
            </span>
            <nuxt-link :to="`mailto:${vars.emailText}`" class="n-link tw-break-all">{{ vars.emailText }}</nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="variants.v2 === variant"
    class="tw-px-6 tw-py-8"
    style="border-radius: var(--rounded)"
    :style="`background-color: var(--c-${vars.backgroundColor});`"
  >
    <h4 class="tw-pb-6">{{ vars.titleText }}</h4>
    <div class="tw-flex tw-h-full tw-min-h-[400px] tw-flex-col tw-gap-6 tw-rounded-lg tw-border-2 tw-p-3 tw-text-start">
      <NuxtImg :src="vars.photoImage" style="border-radius: var(--rounded)" />
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-text-center">
        <p>{{ vars.descriptionText }}</p>
      </div>
    </div>
  </div>

  <div
    v-if="variants.v3 === variant"
    class="tw-flex tw-flex-col tw-gap-6 tw-px-4 tw-py-9 tw-mt-5"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded);`"
  >
    <h3 style="color: #343434 !important;">{{ vars.titleText }}</h3>

    <template v-if="vars.photoImage">
      <library-image :src="vars.photoImage" :h-ratio="1" :w-ratio="1" />
    </template>
    <template v-else-if="vars.videoUrl">
      <library-iframe :src="vars.videoUrl" class="tw-h-[282px] tw-w-full" />
    </template>

    <nuxt-link
                  class="n-link tw-flex tw-flex-row tw-items-center tw-gap-2 tw-border-none"
                  :to="`tel:${vars.phoneText}`"
                style="color: #80C66E !important;">
                  <span >
                   <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.66732 11.3544C1.30065 11.3544 0.986652 11.2237 0.725319 10.9624C0.463985 10.7011 0.333541 10.3873 0.333986 10.0211V2.02108C0.333986 1.65441 0.464652 1.34041 0.725986 1.07908C0.987319 0.817745 1.3011 0.687301 1.66732 0.687745H12.334C12.7007 0.687745 13.0147 0.818412 13.276 1.07975C13.5373 1.34108 13.6678 1.65486 13.6673 2.02108V10.0211C13.6673 10.3877 13.5367 10.7017 13.2753 10.9631C13.014 11.2244 12.7002 11.3549 12.334 11.3544H1.66732ZM7.00065 6.68775L12.334 3.35441V2.02108L7.00065 5.35441L1.66732 2.02108V3.35441L7.00065 6.68775Z" fill="#80C66E"/>
</svg>


                  </span >
                  {{ vars.mailText }}
                </nuxt-link>
                <nuxt-link
                  :to="`mailto:${vars.mailText}`"
                  class="n-link tw-flex tw-flex-row tw-items-center tw-gap-2 tw-border-none"
                >
                  <span>
                    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.34 8.27433C10.52 8.27433 9.72667 8.141 8.98667 7.901C8.87074 7.8617 8.74608 7.85587 8.62699 7.88417C8.5079 7.91246 8.39919 7.97375 8.31333 8.061L7.26667 9.37433C5.38 8.47433 3.61333 6.77433 2.67333 4.821L3.97333 3.71433C4.15333 3.52766 4.20667 3.26766 4.13333 3.03433C3.88667 2.29433 3.76 1.501 3.76 0.680996C3.76 0.320996 3.46 0.0209961 3.1 0.0209961H0.793333C0.433333 0.0209961 0 0.180996 0 0.680996C0 6.87433 5.15333 12.021 11.34 12.021C11.8133 12.021 12 11.601 12 11.2343V8.93433C12 8.57433 11.7 8.27433 11.34 8.27433Z" fill="#80C66E"/>
</svg>

                  </span>
                  <span style="color: #80C66E !important;">{{ vars.phoneText }}</span>
                </nuxt-link>

    <p v-if="vars.descriptionText" style="color: #343434 !important;">{{ vars.descriptionText }}</p>

    <div  class="tw-mt-2 tw-flex tw-flex-col tw-gap-4 lg:tw-flex-row lg:tw-gap-4">
      <nuxt-link
        v-for="(button, index) in buttons"
        :key="`card-btn-${index}`"
        :class="`n-${button.type} tw-w-fit`"
        :to="button.link"
        
        :external="true"
      >
        {{ button.label }}
      </nuxt-link>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'MeetCard',

  mixins: [ComponentMixin],

  
  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
      },
    };
  },

  computed: {
    variant() {
      return useVariant(this.component);
    },

    buttons() {
      return this.groupedVariables.buttons;
    },

    descriptions() {
      return this.groupedVariables.descriptions;
    },
  },
});
</script>
